<!-- Slide editor page header (Phase 3 editor template). The Sharing select
     moved into the toolbar (TopLowerHorizontalBar.vue). -->

<template>
  <header class="pe-header">
    <div class="pe-header__left">
      <div class="pe-header__title-row">
        <h1 class="bui-page-title">Slide Editor</h1>
        <button
          type="button"
          class="pe-header__refresh"
          aria-label="Reload slide"
          :disabled="isReloading"
          @click="handleReloadSlide()"
        >
          <PhArrowsClockwise :size="22" weight="bold" />
        </button>
      </div>
      <div class="pe-header__subtitle">{{ basicInfo.name }}</div>
    </div>
  </header>
</template>

<script lang="ts" setup>
import { PhArrowsClockwise } from '@phosphor-icons/vue';

import useMediaItem from '../../composables/mediaItem';
import useSlide from '@/views/MediaEditorView/SlideEditor/composables/slide';

defineProps<{
  isReadOnly: boolean
}>();


const { reloadMediaItem, isReloading } = useMediaItem();
const { clearSpritesSelection, basicInfo, unsetHasUnsavedChanges } = useSlide();
function handleReloadSlide() {
  clearSpritesSelection();
  reloadMediaItem();
}

</script>

<style lang="scss" scoped>
@import '@/assets/styles/bui-editor-template';
</style>
